
import { Component, Ref, Vue } from 'vue-property-decorator'
import SidemenuLayoutBase from '@/components/organisms/layout/SidemenuLayoutBase.vue'
import SidemenuInformationPanel from '@/components/organisms/manage/SidemenuInformationPanel.vue'
import ModalEditUserData from '@/views/modal/ModalEditUserData.vue'
import ModalEditUserPassword from '@/views/modal/ModalEditUserPassword.vue'
import { AdminSideMenuTopic } from '@/const/manage/AdminSideMenuTopic'
import { AvatarCode } from '@/const/AvatarCode'
import { InformationPanelColorSet } from '@/const/manage/InformationPanelColorSet'
import { UserRole } from '@/const/UserRole'

/**
 * システム管理者用左側メニュー
 *
 * template部品のルート要素で使用し、メイン部分に表示する内容をslotで渡す
 *
 * ex)
 * admin-sidemenu-layout.any-template
 *   .any-template__item 右側メイン部分に表示する内容
 */
@Component({
  components: {
    SidemenuLayoutBase,
    SidemenuInformationPanel,
    ModalEditUserData,
    ModalEditUserPassword,
  },
})
export default class AdminSidemenuLayout extends Vue {
  /** サイドメニュー基底部 */
  @Ref()
  sidemenuLayout!: SidemenuLayoutBase

  /** ユーザ情報編集モーダル */
  @Ref()
  modalEditUserData!: ModalEditUserData

  /** パスワード編集モーダル */
  @Ref()
  modalEditUserPassword!: ModalEditUserPassword

  /** 権限 */
  private readonly role = UserRole.ADMIN

  /** 現在のビューモード(light or dark) */
  private isDarkMode = false

  /** クッキーから取得した先生情報 */
  private admin = this.$appCookies.authAdmin.get()

  /** インフォメーションパネルのカラーセット */
  private informationPanelColorSet: InformationPanelColorSet.ColorSet = InformationPanelColorSet.ADMIN

  /**
   * システム管理者のアイコン画像パス
   *
   * @returns 画像のパス
   */
  private get adminId(): string {
    return this.admin.loginId
  }

  /**
   * システム管理者のニックネーム
   *
   * @returns ニックネーム
   */
  private get adminNickName(): string {
    return this.admin.nickname
  }

  /**
   * システム管理者のアイコン画像パス
   *
   * @returns 画像のパス
   */
  private get imageUrl(): string {
    const code = this.admin.avatarIconCode
    return AvatarCode.findByCode(code).path
  }

  /**
   * メニュー項目一覧
   *
   * @returns 項目リスト
   */
  private get topicList(): AdminSideMenuTopic.Topic[] {
    return AdminSideMenuTopic.LIST
  }

  /**
   * ビューモードを切り替える
   * TODO ダークモード実装後に修正
   */
  private toggleViewMode(): void {
    alert('ダークモード切り替え')
    this.isDarkMode = !this.isDarkMode
  }

  /**
   * 編集ボタン押下時の処理
   */
  private async onEditButton(): Promise<void> {
    await this.modalEditUserData.show(this.admin.userId)
  }

  /**
   * ログアウトボタン押下時の処理
   */
  private onLogoutButton(): void {
    if (!confirm('ログアウトしますか？')) {
      return
    }
    // クッキー情報を削除
    this.$appCookies.removeAuth()
    // ログイン画面に遷移
    this.$router.push('/admin/login')
  }

  /**
   * パスワード変更ボタン押下時の処理
   */
  private onChangePasswordButton(): void {
    this.modalEditUserPassword.show()
  }
}
